import { render, staticRenderFns } from "./merchantsWalletEdit.vue?vue&type=template&id=1580a4e4&scoped=true&lang=pug&"
import script from "./merchantsWalletEdit.vue?vue&type=script&lang=js&"
export * from "./merchantsWalletEdit.vue?vue&type=script&lang=js&"
import style0 from "./merchantsWalletEdit.vue?vue&type=style&index=0&id=1580a4e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1580a4e4",
  null
  
)

export default component.exports